// import type8Credits from "@jeremyfagis/type8-credits";

export default function () {
    // -------------------------------------
    // type8 credits
    // -------------------------------------
    // new type8Credits('.type8_open');
}
